import { render } from "./SideBar.vue?vue&type=template&id=49535010&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-49535010"

export default script